import { isExperimentFlagEnabled } from './useExperimentFlag';

export const isExperimentCartPreviewEnabled = (): boolean => isExperimentFlagEnabled('enable_cart_preview');

export const useExperimentCartPreview = isExperimentCartPreviewEnabled;
